module.exports = __webpack_public_path__ + "static/img/forest-poster.92aedc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/forest-poster.jpg
// module id = 3yQ6
// module chunks = 1